import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';

import { SIGNUP_PATHS } from '../../../constants';
import { useUserToken } from '../../../hooks/userTokenHook';
import { useAppDispatch } from '../../../store';
import {
  checkRegistrationStep,
  getStorageData,
} from '../../../store/actions/signup';

import AgreementStep from './agreement-step/agreement-step';
import CodeStep from './code-step/code-step';
import DocsStep from './docs-step/docs-step';
import InfoStep from './info-step/info-step';
import PasswordStep from './password-step/password-step';
import PhoneStep from './phone-step/phone-step';
import VerificationStep from './verification-step';
import KeyGenerationStep from './key-generation-step';
import KeyGenerationResultStep from './key-generation-step/result';
import PersonSelectStep from './PersonSelectStep';
import IndividualInfoStep from './IndividualInfoStep';

import './signup-form.scss';

const SignupForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const { token } = useUserToken();
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(getStorageData());
    setLoading(false);
  }, []);

  useEffect(() => {
    if (token) {
      dispatch(
        checkRegistrationStep({
          token,
          unAuthCb: () => history.push(SIGNUP_PATHS.NEW),
        })
      );
    }
  }, [token]);

  return (
    <>
      {!loading && (
        <Switch>
          <Route
            path={SIGNUP_PATHS.VERIFICATION}
            component={VerificationStep}
          />
          <Route
            path={SIGNUP_PATHS.KEY_GENERATION}
            component={KeyGenerationStep}
          />
          <Route
            path={SIGNUP_PATHS.KEY_GENERATION_RESULT}
            component={KeyGenerationResultStep}
          />
          <Route
            path={SIGNUP_PATHS.PERSON_SELECT}
            component={PersonSelectStep}
          />
          <Route path={SIGNUP_PATHS.INFO} component={InfoStep} />
          <Route
            path={SIGNUP_PATHS.INDIVIDUAL_INFO}
            component={IndividualInfoStep}
          />
          <Route path={SIGNUP_PATHS.CODE} component={CodeStep} />
          <Route path={SIGNUP_PATHS.DOCS} component={DocsStep} />
          <Route path={SIGNUP_PATHS.AGREEMENT} component={AgreementStep} />
          <Route path={SIGNUP_PATHS.PASSWORD} component={PasswordStep} />
          <Route path={SIGNUP_PATHS.BASE} component={PhoneStep} />
        </Switch>
      )}
    </>
  );
};

export default SignupForm;
